import * as React from 'react';
import SEO from '../components/SEO/SEO';
import HomeV1 from './Home/V1/HomeV1';
import HomeV2 from './Home/V2/HomeV2';
import HomeV3 from './Home/V3/HomeV3';

export function PageLayout(props) {
  const { pageContext } = props;

  const getHomeComponent = React.useCallback(() => {
    if (pageContext.data.V3) return HomeV3;
    if (pageContext.data.V2) return HomeV2;
    return HomeV1;
  }, [pageContext.data.V3, pageContext.data.V2]);

  const Home = getHomeComponent();

  return (
    <>
      <SEO
        fullName={pageContext.data.Full_Name}
        gtm={pageContext.data.GTM}
        metaURL={pageContext.data.metaURL}
        description={pageContext.data.Description}
        OGImage={
          pageContext.data?.OGimage?.localFiles?.[0]?.childrenImageSharp?.[0]
            ?.gatsbyImageData?.images?.fallback?.src
        }
        title={pageContext.data.Title}
      />
      <Home pageContext={pageContext} />
    </>
  );
}
